<div class="d-flex align-items-center">
  @if (showInput()) {
    <input
      class="apm-input input-file me-2"
      type="text"
      [ngClass]="[selectedFile() ? 'file-loaded' : '', disabled() ? 'file-disabled' : '']"
      [placeholder]="'445606' | apmTranslate"
      [ngModel]="selectedFile()?.name"
      [readonly]="true"
    />
  }
  <label for="uploadProjectDocument">
    <apm-icon
      size="md"
      [hasHoverIcon]="true"
      [isButton]="true"
      [matTooltip]="tooltip()"
      [disabled]="disabled()"
      icon="a_add"
    ></apm-icon>
  </label>
  @if (!disabled()) {
    <input
      class="d-none"
      id="uploadProjectDocument"
      #uploadInput
      type="file"
      [accept]="acceptedFile()"
      (click)="uploadInput.value = ''"
      (change)="uploadDocument($event)"
    />
  }
</div>
